// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgCall0224 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M9.62103 3.7173C9.4387 2.42961 8.34123 1.48774 7.05483 1.50012L4.0648 1.50005C3.34366 1.50108 2.65787 1.80344 2.17261 2.3339C1.6899 2.86157 1.44625 3.57125 1.50999 4.27833C1.84982 7.47347 2.9312 10.5193 4.67182 13.2006C6.24368 15.6691 8.34981 17.77 10.8397 19.3488C13.4941 21.0666 16.5304 22.1456 19.6772 22.487C20.4227 22.5545 21.1354 22.314 21.6674 21.8269C22.201 21.3384 22.5023 20.6483 22.4994 19.9236L22.4997 16.9167C22.5315 15.6554 21.5854 14.5349 20.3017 14.3541C19.3712 14.2315 18.4711 14.0077 17.603 13.6845L17.427 13.6257C16.5411 13.3649 15.5716 13.6016 14.9066 14.2578L13.9336 15.2165C11.8153 13.9338 10.0381 12.1604 8.75101 10.044L9.70358 9.0943C10.4151 8.37638 10.6401 7.31952 10.2865 6.38088C9.96507 5.52125 9.7408 4.62375 9.62103 3.7173ZM4.0648 3.00005H7.06927C7.60368 2.99491 8.05916 3.3858 8.13395 3.9138C8.26845 4.93172 8.52006 5.9396 8.88281 6.90965C9.02984 7.29996 8.93631 7.7376 8.64407 8.0325L7.37926 9.29458C7.08227 9.59094 7.02033 10.0488 7.22794 10.4131C8.73281 13.054 10.9241 15.2406 13.5707 16.7423C13.9358 16.9495 14.3946 16.8877 14.6916 16.5913L15.9601 15.3255C16.2519 15.0376 16.6905 14.9443 17.0795 15.0902C18.0537 15.4529 19.0638 15.704 20.0925 15.8394C20.6194 15.9136 21.0131 16.3773 20.9997 16.9165L20.9994 19.9296C21.0006 20.2325 20.8754 20.5183 20.6545 20.7205C20.4336 20.9227 20.1375 21.0227 19.839 20.9957C16.9274 20.6799 14.1144 19.6814 11.643 18.082C9.33803 16.6205 7.38999 14.6766 5.92995 12.3838C4.3172 9.89955 3.31631 7.07895 3.00393 4.14365C2.97847 3.86119 3.0779 3.5666 3.27937 3.34636C3.48085 3.12612 3.76586 3.00048 4.0648 3.00005Z"
				/>
			</Svg>
		);
	}
);
SvgCall0224.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgCall0224;
